import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ValidateService {
  validateEmail(email: string) {
    // const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email) || email === '') {return true;}
    return false;
  }
  validateUrl(url: string) {
    const urlRegex =
      /^((http[s]?:\/\/)+)?[a-zA-Z0-9._-]+(?:\/[a-zA-Z0-9._-]+)*\/[a-zA-Z0-9._-]+\.(png|jpg|jpeg)(\?[^\s]*)?$/;
    return url.match(urlRegex);
  }
}
